import Immutable from 'immutable';

const WistiaUtils = {
  getThumbnail: (videoIn) => {
    const video = Immutable.Map.isMap(videoIn)
      ? videoIn
      : Immutable.Map(videoIn);
    const thumbnailURL = video.get('thumbnail_url');
    return (
      thumbnailURL &&
      `${thumbnailURL.split('?')[0]}?image_crop_resized=640x360&foo`
    );
  },
};

export default WistiaUtils;
